import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faEdit, faEye, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import DashboardHeader from '../../Header/DashboardHeader';
import DashboardFooter from '../../Footer/DashboardFooter';
import DashboardLeftMenu from '../DashboardLeftMenu';
import EmptyImg from "../../Dashboard/assets/img/create-project.png";

const FormList = () => {
    // Dummy data for the table
    const dummyVoiceTemplateList = {
        data: [
            {
                id: 1,
                template_name: "Welcome Message",
                content: "Welcome to our service. How can we help you today?",
                is_active: 1,
                created: "2025-11-06"
            },
            {
                id: 2,
                template_name: "Goodbye Message",
                content: "Thank you for using our service. Have a great day!",
                is_active: 1,
                created: "2025-11-06"
            },
            {
                id: 3,
                template_name: "Hold Message",
                content: "Please hold while we connect you to our representative.",
                is_active: 0,
                created: "2025-11-05"
            }
        ]
    };

    // Scroll to top when component renders
    React.useEffect(() => {
        document.querySelector('body').scrollTo(0, 0);
    }, []);

    return (
        <div className="wrapper">
            <DashboardLeftMenu />
            <div className="main">
                <DashboardHeader />
                <main className="content">
                    <div className="container-fluid p-0">
                        <div className="row mb-2 mb-xl-3">
                            <div className="col-auto d-none d-sm-block">
                                <h3><strong>Created Form</strong> List </h3>
                            </div>

                            <div className="col-auto ml-auto text-right mt-n1">
                                <Link className="btn btn-primary btn-sm" to="/dashboard/create-form">
                                    <FontAwesomeIcon icon={faPlus} color='' /> Create New Form
                                </Link>
                            </div>
                        </div>

                        <div className="table-content-show">
                            <div className="row justify-content-center">
                                <div className="col-12 col-lg-12 col-xxl-12 d-flex">
                                    <div className="card flex-fill table-responsive">
                                        <div className="card-header">
                                            <h5 className="card-title mb-0">Form list</h5>
                                        </div>

                                        {dummyVoiceTemplateList ? (
                                            <table className="table table-hover my-0">
                                                <thead>
                                                    <tr style={{ whiteSpace: 'normal' }}>
                                                        <th>ID</th>
                                                        <th>Form Name</th>
                                                        <th>Form Description</th>
                                                        <th>Status</th>
                                                        <th>Create Date</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dummyVoiceTemplateList.data.map((item, i) => (
                                                        <tr style={{ whiteSpace: 'normal' }} key={i}>
                                                            <td>{item.id}</td>
                                                            <td>{item.template_name}</td>
                                                            <td>{item.content}</td>
                                                            <td>
                                                                {item.is_active === 1 ? (
                                                                    <span className="badge bg-success">Active</span>
                                                                ) : (
                                                                    <span className="badge bg-danger">Inactive</span>
                                                                )}
                                                            </td>
                                                            <td>{item.created}</td>
                                                            <td>
                                                                <Link to={'/dashboard/voice-template/edit/' + item.id}>
                                                                    <span className="badge bg-primary mr-2">
                                                                        <FontAwesomeIcon icon={faEdit} />
                                                                    </span>
                                                                    <span className="badge bg-info mr-2">
                                                                        <FontAwesomeIcon icon={faEye} />
                                                                    </span>
                                                                    <span className="badge bg-danger mr-2">
                                                                        <FontAwesomeIcon icon={faTrashAlt} />
                                                                    </span>
                                                                </Link>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <div className="text-center">
                                                <div className="card-body">
                                                    <img className="project-empty-img" src={EmptyImg} alt="Empty Project" />
                                                    <p>No Form Yet</p>
                                                    <Link className="btn btn-success btn-sm" to="/dashboard/voice-template">
                                                        Create New Form
                                                    </Link>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <DashboardFooter />
            </div>
        </div>
    );
};

export default FormList;